export type DeviceMode = "desktop" | "tablet" | "mobile";

/** Standard device widths/heights for preview */
export const DEVICE_VIEWPORTS: Record<DeviceMode, { width: number; height: number }> = {
  desktop: { width: 1440, height: 900 },
  tablet: { width: 768, height: 1024 },
  mobile: { width: 375, height: 812 },
};
